/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import cs from 'classnames';
import { CSSTransition } from 'react-transition-group';
import InputDate from 'base-ui/dist/InputDate';

import {
  PageWrapper,
  Container,
  Row,
  Col,
  Box,
  Heading,
  Image,
  InputField,
  Paragraph,
  Button,
  Icon,
  Modal
} from 'base-ui';

import UnycosLayout from './UnycosLayout';
import UnycosHeader from './components/UnycosHeader';
import UnycosFooter from './components/UnycosFooter';
import UnycosPaymentForm from './components/UnycosPaymentForm';

/* To show the approval screen that needs to check how it would look if the
 * user was logged in and with a saved card, I did it with just a
 * simple parameter check in the url
*/

class UnycosGift extends Component {
  state = {
    pageTitle: '',
    step: 0,
    cart: [],
    completed: false,
    hasPreAccount: true,
    preAccount: {
      name: '',
      email: '',
      error: false
    },
    gift: {
      nameTo: '',
      emailTo: '',
      message: '',
      date: '',
      sendNow: true
    },

    // for demo purpose
    // eslint-disable-next-line
    isLogged: this.props.location.search ? true : false, 
  }

  componentDidMount() {
    const { cart, isLogged } = this.state;
    let { hasPreAccount, step, pageTitle } = this.state;

    if (isLogged) {
      hasPreAccount = false;
    }

    cart.push({
      title: 'Fundamentos de Maquillaje',
      by: 'Maquillaje',
      price: '€ 99.90',
      thumb: './img/unycos/courses/maquillaje/maquillaje-creativo.jpg'
    });

    step = 1;
    pageTitle = 'Prepara tu regalo';

    this.setState({
      cart,
      hasPreAccount,
      step,
      pageTitle
    });
  }

  handleFromDataChange = (v, t) => {
    const { preAccount } = this.state;

    preAccount[t] = v;
    this.setState({
      preAccount
    });
  }

  handleToDataChange = (v, t) => {
    const { gift } = this.state;

    gift[t] = v;
    this.setState({
      gift
    });
  }

  preAccount = () => {
    const {
      preAccount: {
        name, email, error, errorMessage
      },
      step
    } = this.state;
    const {
      gift: {
        nameTo, emailTo, message, date, sendNow
      }
    } = this.state;

    return (
      <Box id="identification" className={`margin-bottom-medium identification ${(step === 1 ? 'visible' : '')}`}>
        <Heading type="h3" size="medium" textColor="grey" className="text-uppercase margin-bottom-medium">Datos del regalo</Heading>
        <Box className="payment-box payment-option dark-grey-bg text-uppercase margin-bottom-small rounded-small active">
          <Box className="payment-option-body without-margin">
            <Row className={cs('input-wrapper position-relative', { 'coupon-error': error })}>
              <Col xs="12" sm="6">
                <InputField
                  name="name"
                  type="text"
                  label="Regalo De:"
                  full
                  big
                  value={name}
                  placeholder="Nombre"
                  className="without-shadow rounded-small full letter-spacing__small regent-grey-bg"
                  onChange={(v) => this.handleFromDataChange(v, 'name')}
                />
              </Col>
              <Col xs="12" sm="6">
                <InputField
                  name="email"
                  type="email"
                  label="&nbsp;"
                  full
                  big
                  value={email}
                  placeholder="Correo electrónico"
                  className="without-shadow rounded-small full letter-spacing__small regent-grey-bg"
                  onChange={(v) => this.handleFromDataChange(v, 'email')}
                />
                {error && (
                  <Paragraph size="small" textColor="red" className="error-message fade-in without-margin">
                    <Icon name="exclamation-triangle" prefix="fas" />
                    {' '}
                    { errorMessage }
                  </Paragraph>
                )}
              </Col>
            </Row>
            <Row className={cs('input-wrapper position-relative', { 'coupon-error': error })}>
              <Col xs="12" sm="6">
                <InputField
                  name="name-to"
                  type="text"
                  label="Regalo Para:"
                  full
                  big
                  value={nameTo}
                  placeholder="Nombre"
                  className="without-shadow rounded-small full letter-spacing__small regent-grey-bg"
                  onChange={(v) => this.handleToDataChange(v, 'nameTo')}
                />
              </Col>
              <Col xs="12" sm="6">
                <InputField
                  name="email-to"
                  type="email"
                  label="&nbsp;"
                  full
                  big
                  value={emailTo}
                  placeholder="Correo electrónico"
                  className="without-shadow rounded-small full letter-spacing__small regent-grey-bg"
                  onChange={(v) => this.handleToDataChange(v, 'emailTo')}
                />
                {error && (
                  <Paragraph size="small" textColor="red" className="error-message fade-in without-margin">
                    <Icon name="exclamation-triangle" prefix="fas" />
                    {' '}
                    { errorMessage }
                  </Paragraph>
                )}
              </Col>
            </Row>
            <Row className={cs('input-wrapper position-relative', { 'coupon-error': error })}>
              <Col xs="12">
                <InputField
                  name="mensaje"
                  type="textarea"
                  label="Mensaje"
                  full
                  big
                  value={message}
                  placeholder="Mensaje"
                  className="without-shadow rounded-small input full letter-spacing__small regent-grey-bg"
                  onChange={(v) => this.handleToDataChange(v, 'message')}
                />
              </Col>
            </Row>
            <Row className={cs('input-wrapper position-relative', { 'coupon-error': error })}>
              <Col xs="12" md="6">
                <Box className="date-option">
                  <input
                    id="send-later"
                    type="radio"
                    name="send-now"
                    value={false}
                    checked={!sendNow}
                    onChange={(v) => this.handleToDataChange(false, 'sendNow')}
                  />
                  {/* eslint-disable-next-line */}
                  <label htmlFor="send-later">Enviar en una fecha especial</label>
                </Box>
              </Col>
              <Col xs="12" md="6">
                <Box className="date-option">
                  <input
                    id="send-now"
                    type="radio"
                    name="send-now"
                    value
                    checked={sendNow}
                    onChange={(v) => this.handleToDataChange(true, 'sendNow')}
                  />
                  {/* eslint-disable-next-line */}
                  <label htmlFor="send-now">Enviar ahora</label>
                </Box>
              </Col>
            </Row>
            {!sendNow && (
              <Row className={cs('input-wrapper position-relative', { 'coupon-error': error })}>
                <Col xs="12" md="6">
                  <InputDate
                    label="&nbsp;"
                    name="date"
                    className="input input-date big without-shadow rounded-small full text-uppercase letter-spacing__small regent-grey-bgwithout-shadow rounded-small input full text-uppercase letter-spacing__small regent-grey-bg"
                    value={date}
                    onChange={(v) => this.handleToDataChange(v, 'date')}
                  />
                </Col>
              </Row>
            )}
          </Box>
        </Box>
      </Box>
    );
  }

  updateStep(stepNumber) {
    let { step, pageTitle } = this.state;

    switch (stepNumber) {
      case 1:
        pageTitle = 'Prepara tu regalo';
        break;
      case 2:
        pageTitle = 'Revisa la etiqueta';
        break;
      case 3:
        pageTitle = 'Completa tu compra';
        break;
      default:
        break;
    }
    step = stepNumber;
    this.setState({ step, pageTitle });
  }

  render() {
    const {
      pageTitle,
      cart,
      isLogged,
      completed,
      hasPreAccount,
      isModalOpened,
      modalText,
      gift,
      preAccount,
      step,
    } = this.state;

    return (
      <PageWrapper config={{ title: pageTitle }}>
        <UnycosLayout className="payment">
          <UnycosHeader statuslogged={isLogged} showMenu={false} />
          <Container wrap className="margin-top-medium margin-bottom-big">
            <Row className="center-xs">
              {!completed && (
                <Col xs="12">
                  <Box className="hero align-center margin-top-x-big margin-bottom-x-big" style={{ padding: '2vw 0' }}>
                    <Heading
                      type="h2"
                      size="big"
                      textColor="white"
                      className="title normal-font text-uppercase with-letter-spacing"
                    >
                      {pageTitle}
                    </Heading>
                    <div id="step-line" className="step-line">
                      <span className={`step step-gift ${(step >= 1 ? 'active' : '')}`}>
                        <span className="step-label">Prepara tu regalo</span>
                      </span>
                      <span className={`step step-confirm ${(step >= 2 ? 'active' : '')}`}>
                        <span className="step-label">Revisa la etiqueta</span>
                      </span>
                      <span className={`step step-payment ${(step >= 3 ? 'active' : '')}`}>
                        <span className="step-label">Completa tu compra</span>
                      </span>
                    </div>
                  </Box>
                </Col>
              )}
              {completed && (
                <Box className="enhorabuena">
                  <Container fluid>
                    <Heading type="h3" className="title font-size-big white-color title normal-font text-uppercase with-letter-spacing">¡Tu compra ha sido realizada con éxito!</Heading>
                    <Heading type="h4" className="subtitle font-size-medium grey-color margin-bottom-medium">
                      Te informaremos por email cuando
                      {' '}
                      <span className="main-color">{gift.nameTo}</span>
                      {' '}
                      reciba tu regalo.
                    </Heading>
                    <svg className="image" width="30" height="30" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.4001 3.55536H15.0534C15.1599 3.27085 15.2171 2.97023 15.2223 2.66647C15.2037 1.94344 14.8997 1.25716 14.3767 0.757518C13.8538 0.257878 13.1543 -0.0145245 12.4312 -0.000194355C11.7206 0.0151527 11.0271 0.221276 10.4235 0.596593C9.81985 0.97191 9.32823 1.50261 9.00008 2.13314C8.67194 1.50261 8.18032 0.97191 7.57668 0.596593C6.97305 0.221276 6.27961 0.0151527 5.56897 -0.000194355C4.84584 -0.0145245 4.14642 0.257878 3.62346 0.757518C3.10051 1.25716 2.79651 1.94344 2.77786 2.66647C2.78312 2.97023 2.84023 3.27085 2.94675 3.55536H2.60009C2.36618 3.57757 2.139 3.64593 1.93167 3.75648C1.72435 3.86703 1.54099 4.01758 1.39221 4.19942C1.24343 4.38127 1.13217 4.59081 1.06486 4.81592C0.997554 5.04103 0.975538 5.27725 1.00009 5.51092V8.71092C0.958561 9.14135 1.06922 9.57272 1.31283 9.93001C1.55643 10.2873 1.91757 10.5479 2.33342 10.6665V14.5509C2.36086 14.9541 2.54413 15.3308 2.84442 15.6012C3.14471 15.8716 3.53846 16.0146 3.94231 15.9998H14.0579C14.4675 16.0143 14.8663 15.8665 15.1676 15.5885C15.4689 15.3105 15.6483 14.9249 15.6668 14.5154V10.6665C16.0826 10.5479 16.4437 10.2873 16.6873 9.93001C16.9309 9.57272 17.0416 9.14135 17.0001 8.71092V5.51092C17.0246 5.27725 17.0026 5.04103 16.9353 4.81592C16.868 4.59081 16.7567 4.38127 16.608 4.19942C16.4592 4.01758 16.2758 3.86703 16.0685 3.75648C15.8612 3.64593 15.634 3.57757 15.4001 3.55536ZM15.2223 5.51092V8.71092C15.233 8.7697 15.233 8.82992 15.2223 8.8887H9.88897V5.33314H15.2223C15.233 5.39192 15.233 5.45214 15.2223 5.51092ZM12.4312 1.77758C12.683 1.76291 12.9305 1.84793 13.1201 2.01427C13.3097 2.18061 13.4263 2.41489 13.4445 2.66647C13.4263 2.91805 13.3097 3.15234 13.1201 3.31868C12.9305 3.48501 12.683 3.57004 12.4312 3.55536H10.2445C10.4001 3.08049 10.6889 2.66039 11.0766 2.34517C11.4644 2.02995 11.9346 1.83292 12.4312 1.77758ZM4.55564 2.66647C4.5739 2.41489 4.69044 2.18061 4.88006 2.01427C5.06969 1.84793 5.31716 1.76291 5.56897 1.77758C6.06401 1.83453 6.53232 2.03229 6.91833 2.3474C7.30434 2.66252 7.59185 3.08175 7.74675 3.55536H5.56897C5.31716 3.57004 5.06969 3.48501 4.88006 3.31868C4.69044 3.15234 4.5739 2.91805 4.55564 2.66647ZM2.77786 5.51092C2.7672 5.45214 2.7672 5.39192 2.77786 5.33314H8.1112V8.8887H2.77786C2.7672 8.82992 2.7672 8.7697 2.77786 8.71092V5.51092ZM4.1112 10.6665H8.1112V14.222H4.1112V10.6665ZM9.88897 14.222V10.6665H13.889V14.222H9.88897Z" fill="#858479" />
                    </svg>
                  </Container>
                </Box>
              )}
            </Row>

            <div className="stepper-container">
              <CSSTransition in={step === 1} timeout={500} classNames="fadeltr" onEnter={(el) => el.classList.remove('fadeltr-exit-done')}>
                <div className="stepper-step-content stepper-step-content--step1 fadeltr-exit-done">
                  <Row>
                    <Col xs="12" md="7" className="payment-method margin-top-x-small">
                      {hasPreAccount && (
                        <>
                          { this.preAccount() }
                        </>
                      )}
                    </Col>
                    <Col xs="12" md="1"></Col>
                    <Col xs="12" md="4" className="payment-resume margin-top-x-small margin-bottom-small">
                      <Box id="aside-resume" className={step === 1 ? 'visible' : ''}>
                        <Heading type="h3" size="medium" textColor="grey" className="text-uppercase margin-bottom-medium">Resumen</Heading>
                        <Box className="payment-box dark-grey-bg ronded-small rounded-small">
                          {cart.map(({
                            title, by, thumb, price
                          }) => (
                            <Box key={title} className="buy-item margin-bottom-small">
                              <Box className="item item-gift">
                                <Box className="item-info">
                                  <Box className="item-image rounded-small" style={{ backgroundImage: `url('${thumb}')` }}>
                                    <Box className="item-price">
                                      <Heading type="h3" size="normal" textColor="grey">{price}</Heading>
                                    </Box>
                                    <Box className="item-heading text-uppercase">
                                      <Heading type="h3" textColor="grey" size="normal" className="without-margin">{by}</Heading>
                                      <Heading type="h4" textColor="regent-grey" size="normal" className="without-margin normal-font" style={{ textTransform: 'lowercase' }}>
                                        Enseña
                                        {' '}
                                        {title}
                                      </Heading>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          ))}
                          {gift.nameTo && (
                            <>
                              <Box className="gift-card">
                                <Heading type="h3">
                                  {gift.nameTo}
                                  {', '}
                                </Heading>
                                <Paragraph>
                                  {gift.message}
                                </Paragraph>
                                <Paragraph className="align-right without-margin">
                                  -
                                  {' '}
                                  {preAccount.name}
                                </Paragraph>
                              </Box>
                            </>
                          )}
                          <Box>
                            <Button
                              className="btn-gift-continue"
                              tag="button"
                              color="main"
                              textColor="white"
                              borderColor="main"
                              full
                              size="big"
                              onClick={() => this.updateStep(2)}
                            >
                              Continuar
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </Col>
                  </Row>
                </div>
              </CSSTransition>
              <CSSTransition in={step === 2} timeout={500} classNames="fadeltr" onEnter={(el) => el.classList.remove('fadeltr-exit-done')}>
                <div className="stepper-step-content stepper-step-content--step2 fadeltr-exit-done">
                  <Row>
                    <Col xs="12" md="10" mdOffset="1" className="payment-resume margin-top-x-small margin-bottom-small">
                      <Box id="gift-review" className={`payment-box ronded-small rounded-small ${(step === 2 ? 'visible' : '')}`}>
                        <Row className="gift-review-box">
                          {cart.map(({
                            title, by, thumb
                          }) => (
                            <Col xs="12" md="4" key={title}>
                              <Box className="buy-item buy-item-review dark-grey-bg margin-bottom-medium">
                                <Box className="item">
                                  <Box className="item-info">
                                    <Box className="item-image rounded-small" style={{ backgroundImage: `url('${thumb}')` }}></Box>
                                    <Box className="item-heading text-uppercase">
                                      <Heading type="h3" textColor="grey" size="normal" className="without-margin">{by}</Heading>
                                      <Heading type="h4" textColor="regent-grey" size="normal" className="without-margin normal-font" style={{ textTransform: 'lowercase' }}>
                                        Enseña
                                        {' '}
                                        {title}
                                      </Heading>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Col>
                          ))}
                        </Row>
                        {gift && (
                          <>
                            <Box className="gift-card gift-card-review">
                              <Heading type="h3">
                                {gift.nameTo}
                                {', '}
                              </Heading>
                              <Paragraph>
                                {gift.message}
                              </Paragraph>
                              <Paragraph className="align-right without-margin">
                                -
                                {' '}
                                {preAccount.name}
                              </Paragraph>
                            </Box>
                          </>
                        )}
                        {gift && preAccount && (
                          <Box className="gift-email-review">
                            <Paragraph>
                              De:
                              {' '}
                              {preAccount.email}
                            </Paragraph>
                            <Paragraph>
                              Para:
                              {' '}
                              {gift.emailTo}
                            </Paragraph>
                          </Box>
                        )}
                        <Box className="gift-button-box">
                          <Button
                            className="btn-gift-review"
                            tag="button"
                            color="black"
                            textColor="main"
                            borderColor="main"
                            full
                            size="big"
                            onClick={() => this.updateStep(1)}
                          >
                            Editar
                          </Button>
                          <Button
                            className="btn-gift-review"
                            tag="button"
                            color="main"
                            textColor="white"
                            borderColor="main"
                            full
                            size="big"
                            onClick={() => this.updateStep(3)}
                          >
                            Ir al pago
                          </Button>
                        </Box>
                      </Box>
                    </Col>
                  </Row>
                </div>
              </CSSTransition>
              <CSSTransition in={step === 3} timeout={500} classNames="fadeltr" onEnter={(el) => el.classList.remove('fadeltr-exit-done')}>
                <div className="stepper-step-content stepper-step-content--step3 fadeltr-exit-done">
                  <UnycosPaymentForm gift={gift} hasCompleted={() => this.setState({ completed: true })} />
                </div>
              </CSSTransition>
            </div>

            <Modal
              isOpen={isModalOpened}
              appElement="#root"
              closeIcon={false}
              width={784}
              height={400}
              animate={{
                directionFrom: 'bottom',
                effectIni: 300,
                effectEnd: 200,
              }}
              className="modal-processing"
            >
              <Row>
                <Col xs={12} md={5} className="align-center">
                  <Icon name="money-bill-wave" prefix="fas" size="big" color="black" className="pulsate" />
                  <Heading type="h2" size="x-big" className="title normal-font text-uppercase with-letter-spacing">
                    Estamos Procesando tu
                    {modalText}
                  </Heading>
                  <Paragraph>Esto puede tardar algunos segundos no actualices la pantalla.</Paragraph>
                </Col>
                <Col xs={12} md={6} mdOffset={1} className="align-center">
                  <Image src="./img/unycos/process-information.svg" alt="Processing Information" />
                </Col>
              </Row>
            </Modal>
          </Container>
          <UnycosFooter
            showHideElements={{ social: true, cta: true }}
            contactText="Contacta con tu asesor personal"
            contactNumber="0000000"
            goldenButton
            from="landing-page"
          />
        </UnycosLayout>
      </PageWrapper>
    );
  }
}

export default UnycosGift;
